export const INSTAGRAM_URL = `https://www.instagram.com/velvetmooncoffee/`;

export const BRAND_PRIMARY_COLOR = '#962a50';
export const BRAND_NEUTRAL_COLOR = '#ededeb';